

import { atom, getDefaultStore } from "jotai";
import { ControlsApi, CuePointForumData, EditLectureDto, EditScreenDto, ScreenApi, ScreenCuePointDTO } from "../domain/LectureState";
import { LecturePlayingState } from "../domain/LectureState";
import { produce } from "immer";
import api from "src/services/api/axiosService";
import wavfileService from "./waveEdit/WaveFileService";
import { AudioSequence } from "./waveEdit/AudioSequence";
import { FileType, ScreenFileUploadedRequest } from "../domain/ScreenFileUploadedRequest";
import lectureService, { currentLectureatom, LECTUREFILE_UPLOADED, oneLectureatom } from "../LectureService";
import screenEncodingService from "../Screen/ScreenEncodingService";
import localAudioService from "../LocalAudioService";
import fileUploadservice from "src/components/FileUpload/FileUploadService";
import languageService from "src/utils/languageService";
import testService from "src/coursepart/Test/TestService";
1
const store = getDefaultStore();

export enum ScreenJumps {
    first,
    last,
    prev,
    next,
    specificNumber
}


const endPoints = {
    UPDATE_HTML: (screenId: string, lectureId: string) => `/author/coursepart/lecture/${lectureId}/screen/${screenId}/UpdateHtml`,
    SAVE_UPDATE_CUEPOINT: (screenId: string, lectureId: string) => `/author/coursepart/lecture/${lectureId}/screen/${screenId}/SaveUpdateCuePoint`,
    DELETE_CUEPOINT: (screenId: string, lectureId: string, pointId: number) => `/author/coursepart/lecture/${lectureId}/screen/${screenId}/${pointId}/deleteCuePoint`,

}

const dummyAudioUrl = "data:audio/mp3;base64,/+MYxAAAAANIAAAAAExBTUUzLjk4LjIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";
const dummyVideoUrl = "data:video/mp4;base64,AAAAIGZ0eXBpc29tAAACAGlzb21pc28yYXZjMW1wNDEAAAAIZnJlZQAAAAhtZGF0AAAA1m1vb3YAAABsbXZoZAAAAAAAAAAAAAAAAAAAA+gAAAAAAAEAAAEAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAABidWR0YQAAAFptZXRhAAAAAAAAACFoZGxyAAAAAAAAAABtZGlyYXBwbAAAAAAAAAAAAAAAAC1pbHN0AAAAJal0b28AAAAdZGF0YQAAAAEAAAAATGF2ZjU3LjQxLjEwMA==";

const currentPlayingStateAtomPrivate = atom<LecturePlayingState | undefined>(undefined);
currentPlayingStateAtomPrivate.debugLabel = "currentPlayingStateAtomPrivate";

export const currentPlayingStateAtom = atom<LecturePlayingState | undefined>((get) => get(currentPlayingStateAtomPrivate));
currentPlayingStateAtom.debugLabel = "currentPlayingStateAtom";

export const currentScreenAtom = atom(get => {
    const state = get(currentLectureatom);
    if (!state
        || !state.Screens
        || state.Screens.length === 0
        || state.CurrentScreenIndex < 0
        || state.CurrentScreenIndex > state.Screens.length - 1) {

        return undefined;
    }

    return state.Screens[state.CurrentScreenIndex];
},
    (get, set, newVal: EditScreenDto) => {
        const allstate = get(currentLectureatom);
        if (!allstate) return;

        const newState = produce(allstate, state => {
            state.Screens = state.Screens.map((sc, i) => {
                if (state.CurrentScreenIndex === i) {
                    return newVal;
                }
                else {
                    return sc;
                }
            })
        });

        set(currentLectureatom, newState);

    });

currentScreenAtom.debugLabel = "currentScreenAtom";


export class LecturePlayerService {


    fadeControlsTimerId?: number = undefined;
    forceShowControls = false;
    waitingForVideoToStop = false;
    controlapi?: ControlsApi = undefined;
    screenapi: ScreenApi[] = [];
    controls?: ControlsApi = undefined;
    currentScreen = -1;

    constructor() {
        this.screenapi = [];
        this.controlapi = undefined;
    };



    public clearLecture() {


        const oldData = store.get(currentPlayingStateAtomPrivate);
        if (oldData) {

            const state: any = {
                controlsState: {
                    visible: true,
                    fullscreen: false,
                    showingMenu: false

                },
                changeDirection: null,
                autoRepeat: false,
                autoNext: false,
                autoNextTimerId: 0,
                doPlay: false,
                stoppedAtCuePoint: false,
                isPlaying: false,
                playbackRate: 1,
                printstyle: 0,
                showForumDialog: false,
                showTestDialog: false,
                currentPlayed: 0
            }

            store.set(currentPlayingStateAtomPrivate, { ...oldData, ...state });
        } else {
            store.set(currentPlayingStateAtomPrivate, undefined);
        }


    }
    public setVisibleControls(show: boolean) {
        this.alterPlayingState((state) => {
            state.controlsState!.visible = show;
        });
    }

    public toggeleTextEdit() {
        this.alterCurrentScreen((state) => {
            state.EditHtml = !state.EditHtml;
        });
    }

    togglePlayingState() {
        this.alterPlayingState((state) => {
            state.doPlay = !state.doPlay;
        });
    }

    toggleTranscriptEdit() {
        this.alterPlayingState((state) => {

            state.showTranscript = !state.showTranscript;
        });
    }


    shiftScreenNumber(jumpType: ScreenJumps, screenNum?: number) {

        const state = store.get(currentPlayingStateAtomPrivate);
        const currentLecture = store.get(currentLectureatom);
        if (!state || !currentLecture) {
            return -1;
        }

        let slideNum = -1;

        switch (jumpType) {
            case ScreenJumps.first:
                if (currentLecture.CurrentScreenIndex > 0) {
                    slideNum = 0;
                }
                break;

            case ScreenJumps.last:
                if (currentLecture.CurrentScreenIndex < currentLecture.Screens.length - 1) {
                    slideNum = currentLecture.Screens.length - 1;
                }
                break;

            case ScreenJumps.prev:
                if (currentLecture.CurrentScreenIndex > 0) {
                    slideNum = currentLecture.CurrentScreenIndex - 1;
                }
                break;

            case ScreenJumps.next:
                if (currentLecture.CurrentScreenIndex < currentLecture.Screens.length - 1) {
                    slideNum = currentLecture.CurrentScreenIndex + 1;
                }
                break;

            case ScreenJumps.specificNumber:
                if (screenNum !== undefined && screenNum >= 0 && screenNum < currentLecture.Screens.length
                    && screenNum !== currentLecture.CurrentScreenIndex) {
                    slideNum = screenNum
                }

                break;

            default:
                break;
        }

        if (slideNum > -1) {
            this.alterCurrentLecture(draft => {
                draft.CurrentScreenIndex = slideNum;
            });
        }
        return slideNum;

    }


    setFullScreen(fullScreen: boolean) {

        this.alterPlayingState((state) => {
            state.controlsState!.fullscreen = fullScreen;
        });
    }

    setVolume(vol: number) {
        this.alterPlayingState((state) => {

            state.volume = Math.max(vol, 0);
        });
    }

    setPlaybackRate(rate: number) {
        this.alterPlayingState((state) => {

            state.playbackRate = rate;
        });
    }

    async setCurrentLecture(lectureId: string, index: number) {

        this.controlapi = undefined;

        const lectData = store.get(oneLectureatom(lectureId));

        const newData = produce(lectData, draft => {
            draft.AtFirstScreen = index === 0;
            draft.AtLastScreen = index === draft.Screens.length - 1;
            draft.CurrentScreenIndex = Math.min(Math.max(0, index), draft.Screens.length - 1);
            const currentScreen = draft.Screens[index];
            if (currentScreen && currentScreen.CuePoints) {
                currentScreen.CuePoints.forEach(cp => cp.percentPosition = cp.position / 10 / currentScreen.Duration);
            }
        });

        store.set(oneLectureatom(lectureId), newData);

        const lect = store.get(oneLectureatom(lectureId));

        await localAudioService.AttachLocalAudioToScreens(lect.Screens);

        let state: LecturePlayingState | undefined;

        const oldState = store.get(currentPlayingStateAtomPrivate);
        if (oldState) {
            state = { ...oldState };
        }
        else {
            state = {
                showTranscript: false,
                controlsState: {
                    visible: true,
                    fullscreen: false,
                    showingMenu: false

                },
                volume: 100,
                changeDirection: null,
                autoRepeat: false,
                autoNext: false,
                autoNextTimerId: 0,
                doPlay: false,
                stoppedAtCuePoint: false,
                isPlaying: false,
                playbackRate: 1,
                printstyle: 0,
                showForumDialog: false,
                showTestDialog: false,
                currentPlayed: 0

            }

        }

        store.set(currentPlayingStateAtomPrivate, state);

        return state;
    }

    private alterPlayingState(method: (state: LecturePlayingState) => void) {

        var data = store.get(currentPlayingStateAtomPrivate);
        if (!data) return;

        const newstate = produce(data, (draft) => {
            method(draft);
        })
        store.set(currentPlayingStateAtomPrivate, newstate);
    }

    private alterCurrentScreen(method: (state: EditScreenDto) => void) {
        var data = store.get(currentScreenAtom);
        if (!data) return;

        lectureService.mutateScreenState(data.LectureId, data.ScreenId, (screen: EditScreenDto) => {
            method(screen);
        });
    }

    private alterCurrentLecture(method: (state: EditLectureDto) => void) {

        var data = store.get(currentLectureatom);
        if (!data) return;

        lectureService.mutateLecturesState(data.LectureId, (lecture: EditLectureDto) => {
            method(lecture);
        });
    }



    RegisterScreen = (api: ScreenApi) => {
        this.screenapi.push(api);
    }

    RegisterControls = (ctrlApi: ControlsApi) => {
        this.controlapi = ctrlApi;
    }


    SeekTo = (fraction: number, screenType: number) => {
        if (this.screenapi) {
            try {
                this.screenapi.forEach(a => a.seekTo && a.seekTo(fraction, screenType));
            } catch (error) {
                console.error(error);
            }

        }
    }

    mediaPositionChanged(positionInseconds: number, running: boolean) {

        const currentScreen = store.get(currentScreenAtom);

        if (currentScreen && currentScreen.Duration < positionInseconds) {

            const state = store.get(currentPlayingStateAtomPrivate);
            const newData = produce(state, data => {
                data!.stoppedAtCuePoint = true;
            });

            store.set(currentPlayingStateAtomPrivate, newData);

            if (this.waitingForVideoToStop) {
                return null;
            }

            this.waitingForVideoToStop = true;

            return positionInseconds / currentScreen.Duration;
        }

        return null;
    }

    setPlayedPercent(percent: number) {
        this.alterPlayingState(state => {
            state.currentPlayed = percent;
        });
    }

    setPlayerRunningState(runState: boolean) {

        const currentLecture = store.get(currentLectureatom);
        if (currentLecture && currentLecture.Screens) {
            this.alterPlayingState(state => {
                state.isPlaying = runState;
                state.doPlay = runState;
            });
        }
    }

    setWantedPlayingState(playState: boolean) {
        this.alterPlayingState(state => {
            state.doPlay = playState;
        });

    }

    openForumDialog = async (threadId: number) => {
        // const classid = dispatchService.getState().classData.currentClass.Id;
        // forumDuck.getForumDataForClassAndCuePoint(classid, threadId, dispatchService.dispatch);
        // dispatchService.dispatch(SetShowForumDialog(true));

    }

    openTestDialog = async (testid: string) => {


        // //const classid = dispatchService.getState().classData.currentClass.Id;
        // dispatchService.dispatch(courseDuck.setTestInDialog(true));
        // testService.getTestWithoutTypename({ dispatch: dispatchService.dispatch, classid, testid, studyMode: true });

        // dispatchService.dispatch(SetShowTestDialog(true));
    };

    HandleMouseDown = () => {

        this.alterPlayingState(state => {

            if (state.controlsState?.fullscreen) {

                if (state.controlsState.showingMenu) {
                    state.controlsState!.showingMenu = false;
                    if (state.doPlay === true) {
                        this.StartControlsHidingTimer();
                    }
                }
                else if (state.controlsState.visible) {
                    if (state.doPlay === false) {
                        this.StartControlsHidingTimer();
                    }
                    if (!state.stoppedAtCuePoint) {
                        state.doPlay = !state.doPlay;
                    }
                }
                else {
                    state.controlsState!.visible = true;
                    this.StartControlsHidingTimer();
                }
            }
            else {
                if (!state.stoppedAtCuePoint) {
                    state.doPlay = !state.doPlay;
                }
            }
        });
    };

    SetFullScreenControls = () => {
        this.alterPlayingState((s) => {
            s.controlsState!.fullscreen = true;
            s.controlsState!.visible = false;
        });

        if (this.fadeControlsTimerId !== undefined) {
            window.clearTimeout(this.fadeControlsTimerId);
        }
    }

    UnsetFullScreenControls = () => {
        this.alterPlayingState(state => {
            state.controlsState!.fullscreen = false;
            state.controlsState!.visible = true;
        });
        if (this.fadeControlsTimerId !== undefined) {
            window.clearTimeout(this.fadeControlsTimerId);
        }
    }

    StartControlsHidingTimer = () => {
        if (this.fadeControlsTimerId !== undefined) {
            window.clearTimeout(this.fadeControlsTimerId);
        }
        this.alterPlayingState(state => {
            state.controlsState!.visible = true;
        });

        this.fadeControlsTimerId = window.setTimeout(() => {
            this.alterPlayingState(state => {
                state.controlsState!.visible = false;
            });
        }, 2000);
    }

    HandleControlsMenuShowing = (showing: boolean) => {

        this.alterPlayingState(state => {
            if (state.controlsState!.fullscreen) {
                if (showing) {
                    state.controlsState!.visible = true;
                    if (this.fadeControlsTimerId !== undefined) {
                        window.clearTimeout(this.fadeControlsTimerId);
                    }
                }
                else {
                    this.StartControlsHidingTimer();
                }
            }
        });
    }

    ShowControlsPermanent = (show: boolean) => {

        if (show === true) {
            this.forceShowControls = true;
            this.alterPlayingState(state => {
                state.controlsState!.visible = true;
            });
        }
        else {
            this.forceShowControls = false;
            this.StartControlsHidingTimer();
        }
    }

    QuitLecture = () => {
        this.controlapi?.Quit();
    }

    async UpdateHtmlInScreen(lectureId: string, html: string, type: "transcript" | "htmlScreen") {

        const currentScreen = store.get(currentScreenAtom);

        if (!currentScreen) {
            return;
        }
        const screenId = currentScreen.ScreenId;

        await api.post<void>(endPoints.UPDATE_HTML(currentScreen!.ScreenId, lectureId), { html, type });

        lectureService.mutateScreenState(lectureId, screenId, (screen: EditScreenDto) => {
            if (type === "transcript") {
                screen.Transcript = html;
            }
            if (type === "htmlScreen") {
                screen.Html = html;
            }
        });

    }

    public addAudioToScreen(userId: string, partId: string, lectureId: string, screenId: string, audioData?: AudioSequence[]) {

        if (!audioData) {
            throw new Error("No data to add");
        }


        const file = wavfileService.GetWaveFile(audioData);
        if (!file) {
            throw new Error("No data to add");
        }


        const uploadData = fileUploadservice.uploadFile(null, userId, file);
        const duration = audioData[0].getLengthInSeconds();

        uploadData.promise
            .then((fileData) => {
                this.saveAudioFileData(userId, lectureId, partId, fileData.Key!, screenId, duration, file);
            }).catch((e) => {
                console.error(e);
            });

        return uploadData;
    }

    public removeAudioFromScreen(lectureId: string, screenId: string) {

        let currentScreen = store.get(currentScreenAtom);
        if (currentScreen) {

            if (currentScreen.ScreenId === screenId) {
                this.alterCurrentScreen(screen => {
                    screen.Duration = 0;
                    screen.AudioUrl = undefined;
                });

                localAudioService.ClearAudioData(screenId);
            }
        }
    }

    public saveAudioFileData(userId: string,
        lectureId: string,
        partId: string,
        fileKey: string,
        screenId: string,
        duration: number,
        file: File) {

        const data: ScreenFileUploadedRequest = {
            UserID: userId,
            LectureID: lectureId,
            FileKey: fileKey,
            FileName: fileKey,
            FileType: FileType.Sound,
            ScreenID: screenId,
            InsertAfterThisScreen: null
        }

        api.post<EditScreenDto>(LECTUREFILE_UPLOADED(lectureId), data)
            .then(async (response) => {
                if (response && response.data) {
                    screenEncodingService.addScreens([response.data.ScreenId], partId);
                    lectureService.UpdateScreen(response.data);

                    const url = await localAudioService.SaveNewFile(file, screenId, duration);
                    this.alterCurrentScreen(draft => {
                        draft.AudioUrl = url;
                        draft.Duration = duration;
                    });
                }
            });
    }

    public async addCuePoint(position: number) {
        const currentScreen = store.get(currentScreenAtom);
        const currentLecture = store.get(currentLectureatom);

        const cuePoint: ScreenCuePointDTO = {
            id: 0,
            coursePart: currentLecture!.CoursePartId,
            forum: undefined,
            position: Math.round(position),
            mandatoryTestPassed: false,
            test: undefined,
            CuePointID: "",
            Passed: false,
            ThreadId: null,
            percentPosition: 0
        }

        const response = await api.post<ScreenCuePointDTO>(endPoints.SAVE_UPDATE_CUEPOINT(currentScreen!.ScreenId, currentLecture!.LectureId), cuePoint);

        if (response.status === 200) {
            const screenUpdated = produce(currentScreen!, (screen) => {
                const cp = response.data;
                cp.percentPosition = cp.position / 10 / currentScreen!.Duration;
                screen.CuePoints.push(cp);
            });

            store.set(currentScreenAtom, screenUpdated);
        }
    }

    public async setCuePointPosition(percent: number, cuepoint: ScreenCuePointDTO) {
        const currentScreen = store.get(currentScreenAtom);
        const currentLecture = store.get(currentLectureatom);

        let newPoint = { ...cuepoint, position: Math.round(percent * currentScreen!.Duration * 10) };
        const response = await api.post<ScreenCuePointDTO>(endPoints.SAVE_UPDATE_CUEPOINT(currentScreen!.ScreenId, currentLecture!.LectureId), newPoint);
        if (response.status === 200) {
            this.updateAtomAfterAPI(currentScreen!, response.data);
        }
    }

    public async deleteCuePoint(cuePoint: ScreenCuePointDTO) {
        const currentScreen = store.get(currentScreenAtom);
        const currentLecture = store.get(currentLectureatom);

        const response = await api.delete<void>(endPoints.DELETE_CUEPOINT(currentScreen!.ScreenId, currentLecture!.LectureId, cuePoint.id));
        if (response.status === 200) {
            const screenUpdated = produce(currentScreen!, (screen) => {
                screen.CuePoints = screen.CuePoints.filter(p => p.id !== cuePoint.id);
            });
            store.set(currentScreenAtom, screenUpdated);

            if (cuePoint.test) {
                testService.updateTestCuepointData(currentLecture!, cuePoint.test!, true);
            }
        }
    }

    public async updateCuePointForum(cuepoint: ScreenCuePointDTO, forumData: CuePointForumData) {

        const currentScreen = store.get(currentScreenAtom);
        const currentLecture = store.get(currentLectureatom);

        let newPoint: ScreenCuePointDTO = { ...cuepoint, forum: forumData };
        const response = await api.post<ScreenCuePointDTO>(endPoints.SAVE_UPDATE_CUEPOINT(currentScreen!.ScreenId, currentLecture!.LectureId), newPoint);
        if (response.status === 200) {
            this.updateAtomAfterAPI(currentScreen!, response.data);
        }

    }

    public async updateCuePointTest(cuepoint: ScreenCuePointDTO, testId: string) {
        const currentScreen = store.get(currentScreenAtom);
        const currentLecture = store.get(currentLectureatom);

        let newPoint: ScreenCuePointDTO = { ...cuepoint, test: testId };
        const response = await api.post<ScreenCuePointDTO>(endPoints.SAVE_UPDATE_CUEPOINT(currentScreen!.ScreenId, currentLecture!.LectureId), newPoint);
        if (response.status === 200) {
            const cp = response.data;
            this.updateAtomAfterAPI(currentScreen!, cp);

            if (cp.test) {
                testService.updateTestCuepointData(currentLecture!, cp.test);
            }
        }
    }


    public timeFromPercent(percent: number): string {
        const currentScreen = store.get(currentScreenAtom);
        return languageService.gethhmmss(percent * currentScreen!.Duration / 100, true, false, true);
    }


    private updateAtomAfterAPI(currentScreen: EditScreenDto, newPoint: ScreenCuePointDTO) {

        const screenUpdated = produce(currentScreen!, (screen) => {
            screen.CuePoints = screen.CuePoints.map(p => {
                if (p.id == newPoint.id) return { ...newPoint, percentPosition: newPoint.position / 10 / currentScreen!.Duration };
                return p;
            })
        });
        store.set(currentScreenAtom, screenUpdated);
    }


}

const lecturePlayerService = new LecturePlayerService();
export default lecturePlayerService;